import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {catchError, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {of} from 'rxjs';
import { StopLicenseActionTypes } from '../actions/stop-license.actions';
import {LicenseMgtService} from '../../../services/license-mgt.service';
import {Store} from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';



@Injectable()
export class StopLicenseEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private licenseMgtService = inject(LicenseMgtService);

  constructor() {}

  GetStopLicenses$ = createEffect(() => this.actions$.pipe(
    ofType(StopLicenseActionTypes.GetStopLicenses),
    map((action: featureActions.GetStopLicenses) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = { ...payload, otp: user.otp };
      return this.licenseMgtService.StopLicense(params).pipe(
        map((res: UpdateInfoModel) => {
          if (res.result && !res.errmsg) {
            return new featureActions.UpdateInfoSuccessAction({ ...res, type: updateInfoType.StopLicense });
          } else {
            return new featureActions.UpdateInfoFailAction(res);
          }
        }),
        // TODO: catchError Message調整 --> 已完成
        catchError(() => {
          const updateRes: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.StopLicense
          };
          return of(new featureActions.UpdateInfoFailAction(updateRes));
        })
      );
    })
  ));



}